import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";
 
 
 
 
export default function Protestos({
  cartorios
}: {
  cartorios: any
}) {
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {cartorios ? (<span style={{color:'#C70039', fontSize: '1.5rem'}} className="pi pi-exclamation-triangle"><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('protestos')}</span></span>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color:'black'}}>{t('protestos')}</span>)} </div>;
  }
  return (
    <Panel headerTemplate={headerTemplate}>
       {!cartorios && ( <NadaConsta />)}
       {cartorios && cartorios.map((cartorio:any, index:number) => {
        return (
          <>
            {index === 0 && (
              <div>
              <div className="flex-consulta  flex-wrap gap-3">
                {cartorios[0].resumos.map((item:any, index:number) => (
                                 
                    <Card className='flex-1' style={{backgroundColor: '#2e2eb8'}} key={index}>
                        <div className="flex-consulta  justify-content-between gap-5">
                            <div className="flex-consulta  flex-column gap-1">
                                <span style={{color: 'white'}} className=" text-sm">{item.label}</span>
                                <span style={{color: 'white'}} className="font-bold text-lg">{item.value}</span>
                            </div>
                            <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor:'white' , color: '#183462' }}>
                                <i className={item.icon} />
                            </span>
                        </div>
                    </Card>
                  
                  ))}
              </div>
              <br></br>
              <br></br>
            </div>
                            
            
 
            )}
            
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div >
                    <label className="label-dados">{t('cartorio')}</label>
                    <Chip style={{width:"100%"}} label={cartorio.nome} />
                </div>
              </div>
              <div className="col">
              <div >
                    <label className="label-dados">{t('quantidade')}</label>
                    <Chip style={{width:"100%"}} label={cartorio.quantidade} />
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div >
                    <label className="label-dados">{t('uf')}</label>
                    <Chip style={{width:"100%"}} label={cartorio.uf} />
                </div>
              </div>
              <div className="col">
              <div >
                    <label className="label-dados">{t('fone')}</label>
                    <Chip style={{width:"100%"}} label={cartorio.telefone} />
                </div>
              </div>
            </div>
            <div className="grid">
              <div className="col p-fluid flex flex-wrap">
                <div >
                    <label className="label-dados">{t('endereco')}</label>
                    <Chip style={{width:"100%"}} label={cartorio.endereco} />
                </div>
              </div>
            </div>
            {cartorio.protestos ? (
              <>
                <br></br>
               
                <DataTable size="small" value={cartorio.protestos} tableStyle={{ minWidth: '50rem' }}>
                  <Column field="data" header={t('data')}></Column>
                  <Column field="valor" header={t('valor')}></Column>
                </DataTable>
              <br></br>
              <br></br>
              <br></br>
              </>
            ):''}
          </>
        )
       })}
       
      
      
      
    </Panel>
  )
}